module.exports = {"configMetadata":{"url":"https://app-config-tool-backend.ruffcorp.com/api/v1/config_metadata","method":"POST"},"config":{"url":"https://app-config-tool-backend.ruffcorp.com/api/v1/config","method":"POST"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/network.json
// module id = 9n16
// module chunks = 1